/**
 * Shared fetch helper for the memories API (/api/v1/memories).
 * Handles auth headers, error parsing, and 204 no-content responses.
 * Used by: account page MemoriesSection, memories intro modal.
 */

import { env } from "@/env";
import { getAccessToken } from "@/lib/auth/storage";

export async function memoriesFetch(path: string, options?: RequestInit) {
	const token = getAccessToken();
	const res = await fetch(`${env.VITE_API_BASE_URL}/api/v1/memories${path}`, {
		...options,
		headers: {
			"Content-Type": "application/json",
			...(token ? { Authorization: `Bearer ${token}` } : {}),
			...options?.headers,
		},
	});
	if (!res.ok) {
		const err = await res.json().catch(() => ({ detail: "Request failed" }));
		throw new Error(err.detail || "Request failed");
	}
	if (res.status === 204) return null;
	return res.json();
}
